// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AppPromptCtaFieldsFragment = { __typename?: 'AppPromptCta', label: string, url: string };

export type AppPromptImagesFieldsFragment = { __typename?: 'AppPromptImages', light: string, dark: string };

export type AppPromptFieldsFragment = { __typename?: 'AppPrompt', id: string, type: Types.AppPromptType, severity: Types.AppPromptSeverity, title: string, message: string, dismiss_for_seconds?: number | null, cta?: { __typename?: 'AppPromptCta', label: string, url: string } | null, images?: { __typename?: 'AppPromptImages', light: string, dark: string } | null };

export type AppPromptsQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type AppPromptsQuery = { __typename?: 'Query', appPrompts: Array<{ __typename?: 'AppPrompt', id: string, type: Types.AppPromptType, severity: Types.AppPromptSeverity, title: string, message: string, dismiss_for_seconds?: number | null, cta?: { __typename?: 'AppPromptCta', label: string, url: string } | null, images?: { __typename?: 'AppPromptImages', light: string, dark: string } | null }> };

export const AppPromptCtaFieldsFragmentDoc = gql`
    fragment AppPromptCtaFields on AppPromptCta {
  label
  url
}
    `;
export const AppPromptImagesFieldsFragmentDoc = gql`
    fragment AppPromptImagesFields on AppPromptImages {
  light
  dark
}
    `;
export const AppPromptFieldsFragmentDoc = gql`
    fragment AppPromptFields on AppPrompt {
  id
  type
  severity
  title
  message
  dismiss_for_seconds
  cta {
    ...AppPromptCtaFields
  }
  images {
    ...AppPromptImagesFields
  }
}
    ${AppPromptCtaFieldsFragmentDoc}
${AppPromptImagesFieldsFragmentDoc}`;
export const AppPromptsDocument = gql`
    query appPrompts($outfitterId: ID!) {
  appPrompts(outfitterId: $outfitterId) {
    ...AppPromptFields
  }
}
    ${AppPromptFieldsFragmentDoc}`;

/**
 * __useAppPromptsQuery__
 *
 * To run a query within a React component, call `useAppPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppPromptsQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useAppPromptsQuery(baseOptions: Apollo.QueryHookOptions<AppPromptsQuery, AppPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppPromptsQuery, AppPromptsQueryVariables>(AppPromptsDocument, options);
      }
export function useAppPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppPromptsQuery, AppPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppPromptsQuery, AppPromptsQueryVariables>(AppPromptsDocument, options);
        }
export type AppPromptsQueryHookResult = ReturnType<typeof useAppPromptsQuery>;
export type AppPromptsLazyQueryHookResult = ReturnType<typeof useAppPromptsLazyQuery>;
export type AppPromptsQueryResult = Apollo.QueryResult<AppPromptsQuery, AppPromptsQueryVariables>;